













































































import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import UiTableContainer from '../UI/table-container.vue';

@Component({
  components: {
    UiTableContainer
  }
})
export default class PrescriptionDraftListDialog extends BaseComponent {
  @Prop()
  list: any;

  modalOpen = false;

  public headers: any = [
    { text: 'Unidade', value: 'nmUnidade', sortable: true },
    { text: 'Paciente', value: 'nmPaciente', sortable: true },
    { text: 'Data', value: 'data', sortable: true },
    { text: 'Produtos', value: 'data', sortable: false },
    { text: '', value: '', sortable: false, width: '50px' }
  ];

  mounted() {
    this.modalOpen = true;
  }

  public close(): void {
    this.$emit('close');
  }

  public loadDraft(item) {
    this.$emit('load', item);
  }

  public deleteDraft(item) {
    this.dialog.show(
      'error',
      'Excluir Rascunho',
      'Tem certeza que deseja excluir o rascunho do paciente ' + item.nmPaciente + '?',
      'Cancelar',
      '',
      'Excluir',
      () => {
        this.$emit('delete', item);
      }
    );
  }
}
